import { useLogo } from '../../contexts/LogoContext'

interface LogoProps {
  className?: string
  loading?: boolean
}

function LogoComponent({ className, loading = false }: LogoProps) {
  const { msbLogo, msbLogoLoading, msb } = useLogo()

  let logoSrc = msbLogo || `/${msb?.toLowerCase() || ''}.svg`
  if (loading) {
    logoSrc = msbLogoLoading || `/${msb?.toLowerCase() || ''}-loading.svg`
  }

  return <img src={logoSrc} alt={`${msb} logo`} className={className} />
}

function logo(props: LogoProps) {
  return () => <LogoComponent {...props} />
}

export { logo, LogoComponent }
